<button mat-icon-button class="close-button" [mat-dialog-close]="true">
  <mat-icon class="close-icon" color="warn">close</mat-icon>
</button>

<h1 mat-dialog-title>{{ action }} <strong>índice de ajuste</strong></h1>
<mat-divider></mat-divider>

<div mat-dialog-content cdkTrapFocus [cdkTrapFocusAutoCapture]="true">
  <form [formGroup]="form" *ngIf="action != 'Eliminar'; else elseTemplate">

    <!-- Tres columnas iguales. Antes sumaban 3+3+4 = 10 y quedaba un hueco. -->
    <div class="row">
      <div class="col-lg-4">
        <mat-form-field class="full-width">
          <mat-label>Fecha</mat-label>
          <!-- matDatepicker en vez de type="date": el nativo traía su propio
               formato dd/mm/aaaa y su espaciado, distinto al resto del sistema. -->
          <input cdkFocusInitial matInput [matDatepicker]="picker" formControlName="Fecha">
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker startView="multi-year"></mat-datepicker>
          <mat-error *ngIf="f.Fecha.errors?.required">Este campo es <strong>requerido</strong>.</mat-error>
        </mat-form-field>
      </div>

      <div class="col-lg-4">
        <mat-form-field class="full-width">
          <mat-label>Valor</mat-label>
          <input matInput type="number" step="0.01" min="0" formControlName="Valor" placeholder="0,00">
          <mat-error *ngIf="f.Valor.errors?.required">Este campo es <strong>requerido</strong>.</mat-error>
          <mat-error *ngIf="f.Valor.errors?.min">Tiene que ser mayor a cero.</mat-error>
        </mat-form-field>
      </div>

      <div class="col-lg-4">
        <mat-form-field class="full-width">
          <ngx-spinner name="spBusquedaTipoAjusteContrato2" bdColor="rgba(255,255,255,0.8)" size="small"
            color="#009688" type="line-scale" [fullScreen]="false"></ngx-spinner>
          <mat-label>Tipo de ajuste</mat-label>
          <mat-select placeholder="Seleccione opción" formControlName="TiposAjusteContrato">
            <mat-option [value]="tipoAjusteContrato.id"
              *ngFor="let tipoAjusteContrato of lstTiposAjusteContrato; let i = index; trackBy: trackByItems">
              {{ tipoAjusteContrato.descripcion | titlecase }} ({{ tipoAjusteContrato.acronimo | uppercase }})
            </mat-option>
          </mat-select>
          <mat-error *ngIf="f.TiposAjusteContrato.errors?.required">Este campo es <strong>requerido</strong>.</mat-error>
        </mat-form-field>
      </div>
    </div>
  </form>

  <ng-template #elseTemplate>
    <p class="confirmacion">
      ¿Seguro que querés eliminar el índice
      <b>{{ local_data.fecha | date:'dd/MM/yyyy' }}</b> con valor
      <b>{{ local_data.valor }}</b>?
    </p>
  </ng-template>
</div>

<mat-divider></mat-divider>

<div mat-dialog-actions>
  <button mat-raised-button color="primary"
    *appRole="['IndiceAjusteContrato.Crear','IndiceAjusteContrato.Modificar','IndiceAjusteContrato.Eliminar']"
    (click)="doAction()" [disabled]="!form.valid && action != 'Eliminar'">
    <mat-icon>{{ action == 'Eliminar' ? 'delete' : 'check' }}</mat-icon>
    {{ action }}
  </button>
  <button mat-button (click)="closeDialog()" color="warn">
    <mat-icon>cancel</mat-icon> Cancelar
  </button>
</div>
